import { AsyncStorageData } from 'common/interfaces';
import UILogger from 'common/utils/logger';
import { getCurrentTime } from './time-util';
import { DB_AUTH_TOKEN, DB_KEY_USER_DATA } from 'common/constants/db';

const USER_DEVICE_TOKEN = 'device_token';

export const persistLocaleStorageData = async (key: string, value: string) => {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    UILogger.log('Error in setting item in async storage: ', key, value);
  }
};
export const persistSessionStorageData = async (key: string, value: string) => {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    UILogger.log('Error in setting item in async storage: ', key, value);
  }
};

export const fetchLocalStorageData = (key: string) => {
  try {
    const value = localStorage.getItem(key);
    return value;
  } catch (e) {
    UILogger.log('Error in getting item from async storage: ', key);
  }
};
export const fetchSessionStorageData = (key: string) => {
  try {
    const value = sessionStorage.getItem(key);
    return value;
  } catch (e) {
    UILogger.log('Error in getting item from async storage: ', key);
  }
};

export const removeLocalStorageData = async (key: string) => {
  try {
    const value = localStorage.removeItem(key);
    return value;
  } catch (e) {
    UILogger.log('Error in removing item from async storage: ', key);
  }
};

export const removeSessionStorageData = async (key: string) => {
  try {
    const value = sessionStorage.removeItem(key);
    return value;
  } catch (e) {
    UILogger.log('Error in removing item from async storage: ', key);
  }
};
